import { useTranslation } from "react-i18next";

import { Icon } from "@/shared/ui";

import { asOfferBadge, asOfferState, type LimitedOffer } from "../model/types";

/**
 * Ярлык лимитированного предложения (доработки §2.2).
 *
 * Локально в `entities/robot`, а не в `shared/ui`: `Badge`-компонента в ките
 * нет вовсе, и роль бейджа уже играют локальные `StatusChip` и
 * `RequestStatusBadge` — это сложившийся приём. Смысл здесь роботоспецифичный
 * (код ярлыка → подпись, состояние кампании → тон), и единственный потребитель
 * тоже робот. В `shared` он переедет, когда появится второй.
 *
 * Пока кампания принимает деньги, чип показывает ЯРЛЫК («LIMITED») — это
 * приглашение. Как только вход закрылся, он показывает СОСТОЯНИЕ («Лимит
 * исчерпан», «Срок истёк») — потому что приглашать уже некуда, а объяснить
 * закрытую кнопку надо.
 */
const TONES: Record<string, string> = {
  active: "bg-status-profit/15 text-status-profit",
  almost_full: "bg-status-warning/15 text-status-warning",
  scheduled: "bg-background-raised text-text-secondary",
  full: "bg-background-raised text-text-tertiary",
  expired: "bg-background-raised text-text-tertiary",
  paused: "bg-background-raised text-text-tertiary",
};

export function OfferBadgeChip({ offer }: { offer: LimitedOffer }) {
  const { t } = useTranslation();
  const state = asOfferState(offer.state);
  const label = offer.accepts_entries
    ? t(`robots.limited.badge.${asOfferBadge(offer.badge)}`)
    : t(`robots.limited.state.${state}`);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-micro font-semibold uppercase tracking-wide ${TONES[state]}`}
    >
      {offer.accepts_entries ? <Icon name="sparkle" size={11} /> : null}
      {label}
    </span>
  );
}
